import React from 'react';
import { CSSObject } from 'styled-components';
import { Wrapper, StatusStyled, StatusIndicator } from './status.styled';

interface StatusInfoProps {
  noLabel?: boolean;
  label?: string;
  status: {
    title: string;
    color: string;
  };
}
const textStyle: CSSObject = {
  fontWeight: 'normal',
};

export const StatusInfo = ({
  noLabel = false,
  label = 'Status',
  status,
}: StatusInfoProps) => {
  const { title, color } = status;

  return (
    <Wrapper>
      {!noLabel && <StatusStyled>{label}:</StatusStyled>}
      <span style={textStyle} id='statusInfo-title'>
        {title}
      </span>
      <StatusIndicator color={color} />
    </Wrapper>
  );
};
